import { useEffect } from 'react'

/**
 * Fixed brand tab title, identical on every page (product decision 2026-09-02):
 * "BituTravel — Alojamiento corporativo sin complicaciones". Per-route titles
 * were dropped so bookmarks/shares always read the same.
 */
export const APP_TAB_TITLE = 'BituTravel — Alojamiento corporativo sin complicaciones'

export function useDocumentTitle(_titleKey?: string | null) {
  useEffect(() => {
    document.title = APP_TAB_TITLE
  }, [])
}